import { NotificationBanner } from 'www-cms';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLinkComponent } from '../button-link/button-link.component';

@Component({
  selector: 'ss-building-block-notification-banner',
  standalone: true,
  imports: [CommonModule, ButtonLinkComponent],
  templateUrl: './notification-banner.component.html',
  styles: `
    :host {
      position: relative;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBannerBuildingBlockComponent {
  banner = input<NotificationBanner>();
  closeBanner = output<void>();
}
